export const USER_SIGN_IN_CREDENTIALS_ERROR_MESSAGE = 'No token found'
export const USER_PASSWORD_RESET_ERROR_MESSAGE = 'Unauthorized'
export const USER_DOES_NOT_EXISTS = "User doesn't exist"
export const REFUND_PENDING_ORDER_INSUFFICIENT_STRIPE_FUND_ERROR_MESSAGE =
  'The recipient of this transfer does not have sufficient funds in their Stripe balance to reverse this amount.'
export const REFUND_ORDER_AFTER_ACCEPT_INSUFFICIENT_STRIPE_FUND_ERROR_MESSAGE =
  'The recipient of this transfer does not have sufficient funds in their Stripe balance to reverse this amount.'
